import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CREATE_SUPPLIESLIST,
  DELETE_SUPPLIESLIST,
  GET_SUPPLIESLIST,
  GET_SUPPLIES_LOOKUP,
  UPDATE_SUPPLIESLIST,
} from './actionType';

// common success
export const ApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const ApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetSuppliesList = (id) => ({
  type: GET_SUPPLIESLIST,
  payload: { id },
});

export const GetSuppliesLookup = () => ({
  type: GET_SUPPLIES_LOOKUP,
});

export const CreateSuppliesList = (data) => ({
  type: CREATE_SUPPLIESLIST,
  payload: { data },
});

export const UpdateSuppliesList = (id, data) => ({
  type: UPDATE_SUPPLIESLIST,
  payload: { id, data },
});

export const DeleteSuppliesList = (id) => ({
  type: DELETE_SUPPLIESLIST,
  payload: { id },
});
